import(/* webpackMode: "eager", webpackExports: ["formatNumber","FormattedNumber"] */ "/carbonara/apps/webapp/src/lib/formatNumber.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReCaptcha"] */ "/carbonara/node_modules/next-recaptcha-v3/lib/ReCaptcha.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReCaptchaContext","ReCaptchaProvider","useReCaptchaContext"] */ "/carbonara/node_modules/next-recaptcha-v3/lib/ReCaptchaProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["useReCaptcha"] */ "/carbonara/node_modules/next-recaptcha-v3/lib/useReCaptcha.js");
;
import(/* webpackMode: "eager", webpackExports: ["withReCaptcha"] */ "/carbonara/node_modules/next-recaptcha-v3/lib/withReCaptcha.js");
